import {apiClient} from 'common/util/api-client';
import {IndustryKey} from 'common/onboarding/immersive-onboarding/constants';

import {appApiUrl} from '../utils';

export type ImmersiveOnboardingResult = {
  author: string;
  events: [];
  industry: IndustryKey;
  modified: string;
  project_id: number;
};

export function getImmersiveOnboardingSetupGuideInfo(projectId: string): Promise<ImmersiveOnboardingResult> {
  return apiClient.get(appApiUrl(`setup-guide`, {projectId}), undefined);
}

export function updateEventSelection(
  projectId: number,
  events: string[],
  industry: IndustryKey,
): Promise<ImmersiveOnboardingResult> {
  return apiClient.patch(appApiUrl(`setup-guide`, {projectId}), {events, industry});
}
